import styled from 'styled-components';

export const OuterContainer = styled.div<{ height: number }>`
  height: ${props => props.height}rem;
  display: flex;
  flex-direction: row;
  ${props => props.theme.mediaQueries.mediumDown} {
    display: none;
  }
`;

export const BarContainer = styled.div`
  height: 100%;
  width: 0.5rem;
  overflow: hidden;
`;

export const CenterLine = styled.div`
  background-color: ${props => props.theme.colors.capsuleGray10};
  height: 100%;
  width: 0.1rem;
  margin-left: auto;
  margin-right: auto;
`;

export const Bar = styled.div<{ fillHeight: number }>`
  background-color: ${props => props.theme.colors.capsuleGreen60};
  border-radius: ${props => props.theme.radii.small};
  width: 0.4rem;
  height: ${props => props.fillHeight}rem;
  transition: height 500ms ease-in;
`;

export const LabelsContainer = styled.div<{ labelsMargin: number }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: ${props => props.labelsMargin}rem 0;
`;

export const Label = styled.div<{ isActive: boolean; isClickable: boolean }>`
  margin-left: ${props => props.theme.space['1.35']};
  font-family: ${props => props.theme.fonts.circular};
  font-style: normal;
  font-weight: ${props => props.theme.fontWeights.semiBold};
  font-size: ${props => props.theme.fontSizes.small};
  letter-spacing: ${props => props.theme.letterSpacings.one};
  text-transform: uppercase;
  color: ${props => (props.isActive ? props.theme.colors.capsuleGreen60 : props.theme.colors.capsuleGray50)};
  cursor: ${props => (props.isClickable ? 'pointer' : 'inherit')};
`;
